import React from "react";

import Intro from "./header/Intro";
import Contact from "./header/Contact";

import About from "./main/About";
import Education from "./main/Education";
import Experience from "./main/Experience";
import Projects from "./main/Projects";
import Personal from "./main/Personal";

const PrintPage = () => {
  return (
    <div className="print-page-wrapper">
      <button className="button print-hide" onClick={() => window.print()}>
        Save as PDF
      </button>
      <div className="middle">
        <Intro />
        <Contact />
        <About />
        <Education />
        <Experience />
        <Projects />
        <Personal />
      </div>
    </div>
  );
};

export default PrintPage;
